import { ReactNode } from "react";

import { MessageDescriptor } from "react-intl";

export type CardType = "scrum" | "kanban" | "business";

export const CORE_PROJECT: "business" = "business";
export const SOFTWARE_PROJECT: "software" = "software";

export const JWM_TEMPLATE_PREFIX = "com.atlassian.jira-core-project-templates";

export const KANBAN_TEAM_MANAGED_KEY =
    "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban";
export const SCRUM_TEAM_MANAGED_KEY =
    "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum";
export const BLANK_TEMPLATE_TEAM_MANAGED_KEY = `${JWM_TEMPLATE_PREFIX}:jira-work-management-blank-project-team-managed`;

export const TemplateKeys = {
    KANBAN: KANBAN_TEAM_MANAGED_KEY,
    SCRUM: SCRUM_TEAM_MANAGED_KEY,
    BUSINESS: BLANK_TEMPLATE_TEAM_MANAGED_KEY,
    UNKNOWN: ""
} as const;

export const ProductKeys = {
    JSW: SOFTWARE_PROJECT,
    JWM: CORE_PROJECT
} as const;

export type TemplateKeysType =
    | (typeof TemplateKeys)[keyof typeof TemplateKeys]
    | "";
export type ProductKeysType = (typeof ProductKeys)[keyof typeof ProductKeys];
export type TemplateChoiceCategory = {
    name: ProductKeysType;
    displayName: MessageDescriptor;
    logoComponent: ReactNode;
    templateKeys: TemplateKeysType[];
};

export type TemplateChoiceStaticContent = {
    key: TemplateKeysType;
    title: MessageDescriptor;
    cardType: CardType;
    iconSrc: string;
    iconBackground: string;
    summary: MessageDescriptor;
    description: MessageDescriptor;
    status?: MessageDescriptor;
};
